import { useEffect } from 'react';
import { withTranslation } from 'react-i18next';

import AppLoaderV1 from './v1/AppLoader';
import AppLoaderV2 from './v2/AppLoader';

import { useMytaverseEvent } from '@core/dashboard/providers';

import { IAppLoader } from './interfaces';
import { getClientSpecificAppLoader } from '@helpers/clientSpecificUtils';

const AppLoader = ({
  children,
  progressValue,
  showTeleportButton,
  handleTeleportButtonClick,
}: IAppLoader) => {
  const { setShowControls } = useMytaverseEvent();

  const ClientSpecificAppLoader = getClientSpecificAppLoader();

  useEffect(() => {
    setShowControls(false);

    return () => {
      setShowControls(true);
    };
  }, []);

  if (ClientSpecificAppLoader) {
    return (
      <ClientSpecificAppLoader
        progressValue={progressValue}
        showTeleportButton={showTeleportButton}
        handleTeleportButtonClick={handleTeleportButtonClick}
      />
    );
  }

  // if (children) {
  //   return <AppLoaderV1>{children}</AppLoaderV1>;
  // }

  return (
    <AppLoaderV2
      progressValue={progressValue}
      showTeleportButton={showTeleportButton}
      handleTeleportButtonClick={handleTeleportButtonClick}
    />
  );
};

export default withTranslation()(AppLoader);
